import * as Api from '@ViewModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { useErrorMessages } from '../../hooks';
import { ApiClient } from '../../services/api';
import { useStatesOnFetch } from '../utils/useStatesOnFetch';

export const useContact = () => {
	const { state, handleWorking, handleResponse, reset } = useStatesOnFetch<Api.IContact>();

	const userSession = useUserSession();
	const errorMessages = useErrorMessages();

	const client = new ApiClient(userSession);

	const get = async (contactId: string) => {
		handleWorking();
		try {
			const response = await client.getContact(contactId);
			if (!response.success) {
				throw Api.asApiError(response);
			}
			handleResponse(response);
			return response;
		} catch (error) {
			errorMessages.pushApiError(error);
		}
	};

	return {
		...state,
		empty: !state?.data,
		get,
		reset,
		status: state.status,
	};
};
